import { useEffect } from 'react';
import { useIsFirstRender } from '../useIsFirstRender';
function useUpdateEffect(effect, deps) {
    var isFirst = useIsFirstRender();
    useEffect(function () {
        if (!isFirst) {
            return effect();
        }
    }, deps);
}
export default useUpdateEffect;
//# sourceMappingURL=useUpdateEffect.js.map